export default "__VITE_PUBLIC_ASSET__cad92741__"